var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaglineAndImagetypeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1011.09 383.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Imagotipo y tagline en horizontal en blanco") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M473.76,248.09H448.45v78h6.92V295.12h18.39a5.36,5.36,0,0,0,5.57-5.58V253.62a5.35,5.35,0,0,0-1.56-4A5.5,5.5,0,0,0,473.76,248.09Zm-1.35,40.85h-17V254.22h17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M511.57,277.28a46.11,46.11,0,0,0-6.63.6q-3.33.56-6.62,1.05v-1.35h-6.63v48.48h6.63V283.91l12.2-.4v10h6.53V282.71Q517.05,277.28,511.57,277.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.88,277.58H533.24q-5.58,0-5.58,5.63v37.22q0,5.63,5.58,5.63h16.64q5.63,0,5.63-5.63V283.21Q555.51,277.58,549.88,277.58Zm-1,42.65h-14.6V283.41h14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M625.57,248.09H600.26v78h6.93V295.12h18.38a5.37,5.37,0,0,0,5.58-5.58V253.62a5.32,5.32,0,0,0-1.57-4A5.48,5.48,0,0,0,625.57,248.09Zm-1.35,40.85h-17V254.22h17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M665.33,277.58h-16q-5.58,0-5.58,5.63v8.17h6.43v-8.27h14.25v14.6H648.89c-3.76,0-5.63,1.86-5.63,5.58V321q0,5.38,5.43,5.38a69.35,69.35,0,0,0,7.82-.59c2.62-.34,5.25-.68,7.87-1.05v1.35h6.53V283.21C670.91,279.46,669,277.58,665.33,277.58ZM664.48,320l-14.8.3V302.89h14.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 684.36,
    y: 277.58,
    width: 6.53,
    height: 48.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 684.26,
    y: 258.6,
    width: 6.73,
    height: 8.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M726.66,277.28a65.47,65.47,0,0,0-7.87.6q-3.94.56-7.83,1.05v-1.35h-6.62v48.48H711V283.91l14.6-.4v42.55h6.63V282.71C732.19,279.09,730.34,277.28,726.66,277.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M754.06,262.49h-6.53v15.09H741.7v5.83h5.83v37q0,5.63,5.58,5.63h9.42v-5.83h-8.47V283.41h8.47v-5.83h-8.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 773.49,
    y: 258.6,
    width: 6.73,
    height: 8.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 773.59,
    y: 277.58,
    width: 6.53,
    height: 48.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M815.89,277.28a65.47,65.47,0,0,0-7.87.6c-2.63.37-5.23.72-7.83,1.05v-1.35h-6.62v48.48h6.62V283.91l14.6-.4v42.55h6.63V282.71C821.42,279.09,819.57,277.28,815.89,277.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M855.29,278.93q-10.65-1.65-11.8-1.65a8.77,8.77,0,0,0-6.83,2.87,10.29,10.29,0,0,0-2.59,7.15v28.34a10.14,10.14,0,0,0,2.94,7.45,10,10,0,0,0,7.37,3h10.91v12.75H841.45v-6.43h-6.53c0,.5,0,1.31-.08,2.42s-.07,1.95-.07,2.51q0,7.13,5.73,7.13h15.74q5.63,0,5.63-5.63V277.58h-6.58Zm0,41.3h-9.16c-3.66,0-5.48-1.86-5.48-5.58v-26c0-3.72,1.82-5.58,5.48-5.58.86,0,3.92.17,9.16.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "913.65 248.09 906.72 248.09 906.72 326.06 931.63 326.06 931.63 319.93 913.65 319.93 913.65 248.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "950.21 248.09 943.29 248.09 943.29 326.06 968.2 326.06 968.2 319.93 950.21 319.93 950.21 248.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1005.46,248.09H985.39a5.29,5.29,0,0,0-5.53,5.53v66.91a5.29,5.29,0,0,0,5.53,5.53h20.07a5.57,5.57,0,0,0,4-1.55,5.31,5.31,0,0,0,1.59-4V300.75h-7v19.18H986.78V254.22h17.34v17.53h7V253.62a5.3,5.3,0,0,0-1.59-4A5.57,5.57,0,0,0,1005.46,248.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "513.65 193.51 472.09 193.51 472.09 144.34 507.34 144.34 507.34 124.01 472.09 124.01 472.09 78.24 513.05 78.24 513.05 57.51 448.65 57.51 448.65 214.24 513.65 214.24 513.65 193.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M721.66,214.24V125.61q0-12.52-12.72-12.52H670.18q-12.91,0-12.91,12.52v18.93H678V130.12h21.93v23.23H669q-12.91,0-12.92,12.52v36.45q0,12.33,12.52,12.32c8.25,0,26.21-5.09,31.15-6.87v6.47ZM678,196.82V168.87h21.93V196Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M627.42,112.69c-5.83,0-20.42,4.06-31.92,7.64-1.4-5.08-5.37-7.64-11.94-7.64-5.85,0-20.53,4.09-32,7.68v-7.28H528.58V214.24h22.93V132.62l21.54-.4v82h23V132.61l20.82-.39v82h23V125Q639.94,112.7,627.42,112.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M866.48,194.31l-21.53.4v-82h-23v89.23q0,12.33,12.52,12.32c5.85,0,20.53-4.09,32.05-7.68v7.28h22.93V112.69H866.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M805.59,214.24V125q0-12.32-12.52-12.32c-5.85,0-20.53,4.09-32.05,7.68v-7.28H738.09V214.24H761V132.62l21.53-.4v82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M958.41,113.09H918.86q-12.93,0-12.93,12.52v76.12q0,12.51,12.93,12.51h39.55q12.93,0,12.92-12.51V180.59H949.4v16.83H927.87V169.07h33.29l10.17-10.17V125.61Q971.33,113.09,958.41,113.09Zm-9,41.06H927.87V129.92H949.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 988.56,
    y: 57.51,
    width: 22.53,
    height: 156.73
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "314.16 170.69 153.67 186.13 300.38 119.26 279.26 82.69 148 176.31 241.62 45.05 205.05 23.93 129.37 189.98 129.37 193.62 205.05 359.67 241.62 338.55 148 207.29 279.26 300.91 300.38 264.34 153.67 197.47 314.16 212.91 314.16 170.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.37,206.71l-5.71,4.21-.35-.2a243.17,243.17,0,0,1-28.08,15.81A182.68,182.68,0,0,1,80.45,294,179.35,179.35,0,0,1,100,383.6h36.51A218.41,218.41,0,0,0,56.37,206.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.58,182.94a221.23,221.23,0,0,0,61.18-70.43l.81-1.51A219.48,219.48,0,0,0,136.47,0H100c3.13,64.49-30.9,128.57-86,162.49l.11,0L9.73,165l-1.3.75L8,166C5.34,167.51,2.68,169,0,170.3v40.1a218.24,218.24,0,0,0,47.24-26.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaglineAndImagetypeWhite);
export default __webpack_public_path__ + "static/media/tagline-and-imagetype-white.ad42355569402899c25d2711fa2a0d16.svg";
export { ForwardRef as ReactComponent };